export const CUSTOMER_ACTIVE_REWARDS_TYPES = {
    reward: "reward",
    redeem: "redeem",
    tier: "tier",
    referrer: "referrer",
    referred: "referred",
} as const;

export const CUSTOMER_DELAYED_REWARDS_TYPES = {
    shareTheShopRewardDelay: "shareTheShopRewardDelay",
    followOnTiktokRewardDelay: "followOnTiktokRewardDelay",
    followOnYoutubeRewardDelay: "followOnYoutubeRewardDelay",
    followOnCustomRewardDelay: "followOnCustomRewardDelay",
    newsletterSubscribeRewardDelay: "newsletterSubscribeRewardDelay",
    facebookPageVisitRewardDelay: "facebookPageVisitRewardDelay",
    followOnInstagramRewardDelay: "followOnInstagramRewardDelay",
    leaveReviewRewardDelay: "leaveReviewRewardDelay",
    placeOrderRewardDelay: "placeOrderRewardDelay",
    createAccountRewardDelay: "createAccountRewardDelay",
    buyXtoGetYRewardDelay: "buyXtoGetYRewardDelay",
    spendXToGetYRewardDelay: "spendXToGetYRewardDelay",
    shareToTwitterRewardDelay: "shareToTwitterRewardDelay",
    shareToFacebookRewardDelay: "shareToFacebookRewardDelay",
    followOnTwitterRewardDelay: "followOnTwitterRewardDelay",
    punchCardRewardDelay: "punchCardRewardDelay",
    customActionRewardDelay: "customActionRewardDelay",
} as const;

export const CUSTOMER_ACTIVE_REWARDS_DISCOUNT_TYPES = {
    fixedAmount: "fixed_amount",
    percentage: "percentage",
    freeShipping: "free_shipping",
    freeProduct: "free_product",
    giftCard: "gift_card",
} as const;
